import template from "./invoice-list.html";
import "./invoice-list.less";

import invoiceTransactionsModule from "./invoice-transactions/invoice-transactions";
import {
	ACTION_EXPAND_INVOICES,
	ACTION_COLLAPSE_INVOICES
} from "constants.js";
import { showInvoiceDetailsModal } from "../modals/invoice-details-modal/invoice-details-modal";

export function controller($uibModal, $scope) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.toggleInvoice = toggleInvoice;
	ctrl.toggleGroupExpansion = toggleGroupExpansion;
	ctrl.hasExpandableInvoices = hasExpandableInvoices;
	ctrl.openInvoiceDetails = openInvoiceDetails;

	function onInit() {
		ctrl.eventBus = ctrl.reportScope.events;

		if(ctrl.invoices.isGroupExpanded === undefined) {
			ctrl.invoices.isGroupExpanded = true;
		}
		ctrl.invoices.isInvoicesExpanded = false;

		ctrl.eventBus.register(ACTION_EXPAND_INVOICES, expandForPrint, $scope);
		ctrl.eventBus.register(ACTION_COLLAPSE_INVOICES, collapseForPrint, $scope);
	}

	function expandForPrint() {
		ctrl.invoices.isGroupExpanded = true;
		ctrl.invoices.items.forEach(invoice => {
			invoice.isExpanded = true;
		});
		ctrl.invoices.isInvoicesExpanded = true;
	}

	function collapseForPrint() {
		ctrl.invoices.items.forEach(invoice => {
			invoice.isExpanded = false;
		});
		ctrl.invoices.isInvoicesExpanded = false;
	}

	function toggleGroupExpansion() {
		if(!ctrl.invoices.items.length)return;

		const allExpanded = ctrl.invoices.items.every(i => i.isExpanded);
		ctrl.invoices.isInvoicesExpanded = !allExpanded;
		ctrl.invoices.items.forEach(invoice => {
			invoice.isExpanded = ctrl.invoices.isInvoicesExpanded;
		});
		ctrl.onToggle();
	}

	function toggleInvoice(invoice) {
		invoice.isExpanded = !invoice.isExpanded;
		ctrl.invoices.isInvoicesExpanded = ctrl.invoices.items.every(i => i.isExpanded);
	}

	function hasExpandableInvoices() {
		return ctrl.invoices.items.length > 0;
	}

	function openInvoiceDetails(invoice) {
		return showInvoiceDetailsModal($uibModal, invoice);
	}
}

const invoiceListModule = "vesl.components.invoice-list";

export default angular
	.module(invoiceListModule, [invoiceTransactionsModule])
	.component("invoiceList", {
		bindings: {
			invoices: "<",
			onToggle: "&"
		},
		require: {
			reportScope: "^^reportScope"
		},
		controller,
		template
	})
	.name;
